import { mpBackend } from '../../config/axios';
export interface ICountry {
  name: string;
  code: string;
  dialCode: string;
}

export interface IState {
  id: number;
  name: string;
  country: string;
}
export const getCountryApi = (): Promise<ICountry[] | []> => {
  return mpBackend
    .get('country/code')
    .then((data: ICountry[]) => {
      return data;
    })
    .catch(() => []);
};

export const getStatesApi = (planId: string): Promise<IState[] | []> => {
  return mpBackend
    .get(`states?planId=${planId}`)
    .then((data: IState[]) => {
      return data;
    })
    .catch(() => []);
};
